import React from 'react';
import './About.css';

import { Button, Heading} from '../../../components';
import { about } from '../../../constants';



const About = () => {

  const { sub, heading, description, points, image, button } = about;

    // Split points into two arrays
    const firstGroup = points.slice(0, 2);
    const secondGroup = points.slice(2);

  return (
    <section className="about">

      {/* About Image */}
      <div className="image">
        <div className="sub-image one">
          <img src={image.src1} alt={image.alt1} />
        </div>
        <div className="sub-image two">
          <img src={image.src2} alt={image.alt2} />
          <img src={image.src3} alt={image.alt3} />
        </div>
      </div>

      {/* Introduction Content */}
      <div className="content">

        {/* Section Heading */}
        <Heading title={heading} subTitle={sub} sideHeading />

        {/* Description */}
        {description.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}

        {/* Key Features */}
        <div className="about-features">
          <div className="feature-group">
            {firstGroup.map((point, index) => (
              <ul key={index}>
                <li>
                  <div className='icon'>{point.icon}</div>
                  <span>{point.title}</span>
                </li>
              </ul>
            ))}
          </div>
            <div className="feature-group">
              {secondGroup.map((point, index) => (
                <ul key={index}>
                  <li>
                    <div className='icon'>{point.icon}</div>
                    <span>{point.title}</span>
                  </li>
                </ul>
              ))}
            </div>
        </div>

        {/* Button Component: Links to a specific page or action */}
        <Button link={button.link} title={button.text} />

      </div>
    </section>
  );
};

export default About;